import StandUp from './StandUp';
export default StandUp;
